import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Checkbox, FormControlLabel, TextField, Autocomplete, Chip} from '@mui/material'
import {Controller} from 'react-hook-form'

export default ({form}) => {
    const [selectedLanguages, setSelectedLanguages] = useState([])

    const languages = [
        {key: 'en', value: 'English'},
        {key: 'es', value: 'Spanish'},
        {key: 'fr', value: 'French'},
        {key: 'zh', value: 'Chinese'},
    ]

    useEffect(() => {
        if (form.getValues('languages')) {
            selectedLanguages.length = 0
            form.getValues('languages').forEach(key => {
                selectedLanguages.push(languages.find(language => language.key == key))
            })
        }
    }, [])

    useEffect(() => {
        form.setValue(
            'languages',
            selectedLanguages.map(lang => lang.key),
        )
    }, [selectedLanguages])

    return (
        <>
            <Typography variant="overline" color="text.secondary">
                language & preferences
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Pet Preferences
            </Typography>
            <br />
            <Controller
                {...form.register('comfortableWithDogs')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Comfortable with dogs"
                    />
                )}
            />
            <br />
            <Controller
                {...form.register('comfortableWithCats')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Comfortable with cats"
                    />
                )}
            />
            <br />
            <Controller
                {...form.register('ableToAssistWithPetCare')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Able to assist with pet care (feeding, walking, cleaning)"
                    />
                )}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Gender Preferences
            </Typography>
            <br />
            <div className="check">
                <Controller
                    {...form.register('man')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Man"
                        />
                    )}
                />
                <Controller
                    {...form.register('woman')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Woman"
                        />
                    )}
                />
            </div>
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Availability
            </Typography>
            <br />
            <div className="check">
                <Controller
                    {...form.register('fullTime')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Full-time"
                        />
                    )}
                />
                <Controller
                    {...form.register('partTime')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Part-time"
                        />
                    )}
                />
                <Controller
                    {...form.register('liveIn')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Live-in"
                        />
                    )}
                />
                <Controller
                    {...form.register('hourlyShifts')}
                    control={form.control}
                    render={({field}) => (
                        <FormControlLabel
                            control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                            label="Hourly shifts"
                        />
                    )}
                />
            </div>
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Language Spoken
            </Typography>
            <Autocomplete
                multiple
                options={languages}
                value={selectedLanguages}
                onChange={(e, newVal) => setSelectedLanguages(newVal)}
                isOptionEqualToValue={(opt, val) => opt.key === val.key}
                getOptionLabel={opt => opt.value}
                renderInput={params => <TextField {...params} placeholder="Add your languages" />}
                slotProps={{chip: {sx: {display: 'none'}}}}
            />
            <div className="languange">
                {selectedLanguages.map(item => (
                    <Chip
                        key={item.key}
                        label={item.value}
                        onDelete={() => setSelectedLanguages(prev => prev.filter(p => p.key !== item.key))}
                        variant="contained"
                        size="medium"
                    />
                ))}
            </div>
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Environment & Lifestyle
            </Typography>
            <br />
            <Controller
                {...form.register('comfortableWorkingInaHouseholdWithSmokers')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Comfortable working in a household with smokers"
                    />
                )}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Additional Care Skills
            </Typography>
            <br />
            <Controller
                {...form.register('hasValidDriversLicenseClient')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Has valid driver’s license / can drive client"
                    />
                )}
            />
            <br />
            <Controller
                {...form.register('skilledInWoundCareManagement')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Skilled in wound care management"
                    />
                )}
            />
            <br />
            <Controller
                {...form.register('experiencedInPhysicalTherapyAssistance')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Experienced in physical therapy assistance"
                    />
                )}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Medical equipment assistance
            </Typography>
            <br />
            <Controller
                {...form.register('experiencedUsingMobilityEquipment')}
                control={form.control}
                render={({field}) => (
                    <FormControlLabel
                        control={<Checkbox {...field} checked={field.value ?? false} onChange={e => field.onChange(e.target.checked)} />}
                        label="Experienced using Hoyer lift / mobility equipment"
                    />
                )}
            />
        </>
    )
}
